import { combineReducers } from 'redux';
import { schoolSubscription } from './schoolSubscription';

export const payment = combineReducers({
    schoolSubscription,
})
